module.exports = __webpack_public_path__ + "static/media/stack.766b5a64.png";